// ─────────────────────────────────────────────
//  native/NativeBridge.jsx — native side-effects mount (Phase 6, D-12)
//
//  Renders nothing. Mounted once inside AuthProvider: when a user is
//  signed in on a native platform it registers the device for FCM push
//  and files the token on the user's doc. Web: pure no-op.
//
//  Anesthesia Team Control (ATC)
//  Copyright © 2026 Gonzalo Martinez (gamc00@gmail.com). All rights reserved.
// ─────────────────────────────────────────────
import { useEffect } from "react";
import { useAuth } from "../context/AuthContext";
import { isNative } from "./platform";
import { registerPushForUser } from "./push";

export default function NativeBridge() {
  const { user } = useAuth();
  const uid = user?.uid || null;

  useEffect(() => {
    if (!isNative() || !uid) return;
    registerPushForUser(uid);
  }, [uid]);

  return null;
}
